import React, { useEffect, useState } from 'react'
import { Amplify, API, graphqlOperation } from 'aws-amplify'
import { Container, Row, Col } from "reactstrap";
import {Link} from 'react-router-dom'
import Helmet from "../components/Helmet/Helmet";
import CommonSection from "../components/UI/CommonSection";
import ProductItem from "../components/UI/ProductItem";
import {listProducts} from '../graphql/queries'
import { useParams } from "react-router-dom";

const listProductLinks = [{}]

const ProductListing = () => {
  const { slug } = useParams();
  // const {image,navigateTo,title} = props.item

 
  console.log(slug,"slug");

  const [listProduct, setlistProductCat] = useState(listProductLinks)

  useEffect( () => {
    fetchTodos()
 }, [])
  const fetchTodos = async ()=> {
     try {
       console.log(slug, "inside fetch")
       const listProductCatData = await API.graphql(graphqlOperation(listProducts, { filter: { category: { eq: slug } } }));
console.log(listProductCatData, "listProductCatData")

       const _productCategoriesList = listProductCatData?.data?.listProducts?.items
       console.log(_productCategoriesList, "_productCategoriesList")
       setlistProductCat(_productCategoriesList)
     } catch (err) { console.log(err, 'error fetching listMenu') }
   }


  return (
    <Helmet 
      title= "product"
    >
      <CommonSection 
      title= "Product Listing"
      />
     
     
      <section>
        <Container>
          <Row>
            <Col lg="12">
             
            </Col>
             
            {listProduct.map((productsList, index) => (
              
              <Col lg='4' md='4' sm='6' className='mb-5' key={index}>
              <Link to={`/product/${productsList.navigateTo}`}>
              <div className='car__item'>
                  <div className="car__img">
                    <img src={ productsList.productIamge}
                    height="250px"
                    // width="150px"
                    alt="" className='w-100' />
                  </div>
                  <div className="car__item-content mt-4">
                      <h4 className="section__title text-center">
                        {productsList.title}
                        
                      </h4>
                     
                  </div>
              </div>
              </Link>
          </Col>
            ))}
          </Row>
        </Container>
      </section>
    </Helmet>
  );
};

export default ProductListing;
